import { useEffect, useRef } from 'react';
import { fatturazioneAPI } from '../services/fatturazioneApi';

const aperte = new Map();   // id della bozza -> quante schermate la tengono

const sembraVuota = (b) => !!(b && b.fattura && b.fattura.id
    && b.fattura.stato === 'bozza'
    && (b.fattura.tipo_documento || 'fattura') === 'fattura'
    && Array.isArray(b.righe) && b.righe.length === 0);

/**
 * useTogliBozzaVuota — la bozza di fattura VUOTA si toglie da sola quando
 * la schermata la lascia (D5 delle prove di Alex, via del 4/10/2026).
 *
 * La bozza nasce prima delle righe: dal «Nuovo documento» quando si sceglie
 * l'intestatario, dalla cassa del paziente con «Crea comunque un
 * documento». Chi chiudeva senza aggiungere niente lasciava nell'elenco una
 * bozza vuota. Adesso, quando la schermata lascia la bozza - la finestra si
 * chiude, si cambia pagina, se ne apre un'altra - e l'ultima versione che
 * ha visto non aveva righe, chiede al server di toglierla. DECIDE IL SERVER
 * (bozza_vuota, migration 295, poi eliminaLaBozza): una riga aggiunta da
 * un'altra postazione, una nota, un numero, e la bozza resta. Qui si guarda
 * solo per non chiedere a ogni chiusura.
 *
 * Chi chiude il browser non passa di qui: le bozze vuote dei giorni prima
 * le toglie il lavoro notturno (scripts/togliBozzeVuote.js), con la stessa
 * regola.
 *
 * PERCHE' IL CONTATORE E IL RINVIO. In sviluppo React (StrictMode) monta,
 * smonta e rimonta ogni componente appena nato: senza, la finestra del
 * «Nuovo documento» toglierebbe la bozza un attimo dopo averla creata. Si
 * toglie solo se, finito il giro, nessuno la tiene piu' aperta.
 *
 * @param {object}   bozza    { fattura, righe } come lo manda GET /fatturazione/:id
 * @param {function} onTolta  facoltativa: dopo che il server l'ha tolta (per
 *                            ricaricare un elenco che la mostrava)
 */
export function useTogliBozzaVuota(bozza, onTolta) {
    const ultima = useRef(bozza);
    const dopo = useRef(onTolta);
    useEffect(() => { ultima.current = bozza; }, [bozza]);
    useEffect(() => { dopo.current = onTolta; }, [onTolta]);

    const id = bozza?.fattura?.id ?? null;
    useEffect(() => {
        if (!id) return undefined;
        aperte.set(id, (aperte.get(id) || 0) + 1);
        return () => {
            aperte.set(id, (aperte.get(id) || 1) - 1);
            const b = ultima.current;
            const richiamo = dopo.current;
            setTimeout(() => {
                if ((aperte.get(id) || 0) > 0) return;
                aperte.delete(id);
                if (!sembraVuota(b) || b.fattura.id !== id) return;
                fatturazioneAPI.togliSeVuota(id)
                    .then((r) => { if (r.data?.data?.tolta && richiamo) richiamo(id); })
                    /* Un errore qui non si mostra: chi ha chiuso non ha chiesto
                       niente, e la bozza vuota la toglie il lavoro notturno. */
                    .catch(() => {});
            }, 0);
        };
    }, [id]);
}

export default useTogliBozzaVuota;
